<ion-app>
  <!--
    Shared menu body — rendered both inside the overlay drawer (narrow
    viewports) and inside the permanent sidebar (wide viewports), so the
    list/styling stays in a single place. Built from plain elements to avoid
    ion-menu/ion-item lifecycle quirks in this customized layout.
  -->
  <ng-template #menuBody>
    <div class="menu-shell">
      <div class="menu-header">
        <img src="/assets/icon/logo.png" alt="HAI Bench" class="logo">
      </div>

      <nav class="menu-nav">
        @for (p of appPages; track p.url) {
        <a class="menu-item" [routerLink]="[p.url]" routerLinkActive="selected" (click)="onMenuItemClick()">
          <ion-icon class="menu-item__icon" aria-hidden="true" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'"></ion-icon>
          <span class="menu-item__label">{{ p.title | translate }}</span>
        </a>
        }
      </nav>

      <!-- Shown once a newer release is downloaded (web) or published to the store (native). -->
      <button
        type="button"
        class="update-banner"
        *ngIf="core.versionService.updateAvailable$ | async"
        (click)="onUpdateClick()"
      >
        <span class="update-banner__icon-wrapper">
          <ion-icon name="sparkles-outline" aria-hidden="true"></ion-icon>
        </span>
        <span class="update-banner__text">
          <span class="update-banner__title">{{ 'New version available' | translate }}</span>
          <span class="update-banner__subtitle">{{ 'Click to update' | translate }}</span>
        </span>
        <ion-icon class="update-banner__chevron" name="arrow-forward-outline" aria-hidden="true"></ion-icon>
      </button>

      <div class="app-version">
        <small>&copy; HAI Bench v{{core.version}}</small>
      </div>
    </div>
  </ng-template>

  <!-- Impersonation banner — shown while a superadmin is acting as another user. -->
  <div class="impersonation-banner" *ngIf="core.auth.isImpersonating">
    <span class="impersonation-banner__text">
      {{ 'Impersonating' | translate }} <strong>{{ core.auth.user?.name || core.auth.user?.email }}</strong>
    </span>
    <button type="button" class="impersonation-banner__exit" (click)="stopImpersonating()">
      {{ 'Back to my account' | translate }}
    </button>
  </div>

  <ng-container *ngIf="(core.appIsReady$|async)===true">
    <div class="app-shell" [class.impersonating]="core.auth.isImpersonating">
      <!-- Permanent sidebar — wide viewports only, driven by our own matchMedia. -->
      <aside class="permanent-sidebar" *ngIf="(showMenu$|async) && (isWide$|async)">
        <ng-container *ngTemplateOutlet="menuBody"></ng-container>
      </aside>

      <ion-router-outlet id="main-content"></ion-router-outlet>
    </div>

    <!--
      Overlay drawer — narrow viewports only. A plain scrim + sliding panel;
      open/close is pure CSS driven by the `drawer--open` class.
    -->
    <div
      class="drawer"
      [class.drawer--open]="(menuOpen$|async)"
      [class.impersonating]="core.auth.isImpersonating"
      *ngIf="(showMenu$|async) && (isWide$|async)===false"
    >
      <div class="drawer__scrim" (click)="closeMenu()"></div>
      <nav class="drawer__panel">
        <ng-container *ngTemplateOutlet="menuBody"></ng-container>
      </nav>
    </div>

    <!-- Floating open-drawer handle — narrow viewports only. -->
    <div class="responsive-menu-trigger" *ngIf="(showMenu$|async) && (isWide$|async)===false">
      <button type="button" class="drawer-handle" [attr.aria-label]="'Open sidebar' | translate" (click)="openSideMenu()"></button>
    </div>
  </ng-container>

  <div *ngIf="(core.appIsReady$|async)===false || (core.appIsReady$|async)==='error'" class="loading-page">
    <img src="/assets/icon/logo.png" alt="HAI Bench" class="logo">
    <ion-spinner name="lines-small" *ngIf="(core.appIsReady$|async)===false"></ion-spinner>
    <ion-text *ngIf="(core.appIsReady$|async)==='error'" color="danger">{{ 'Error initializing app. Check for updates or contact support.' | translate }}</ion-text>
  </div>
</ion-app>
